import Axios from 'axios';
import config from './config.service';
import {env} from '@/services/env.service';
import { useTheming } from '@odin/vue2-utils';
import store from '../store';
import { StoreActions } from '../store/const.enum';
import { setConfigValues, Theme, useTheming as useThemingService } from '@odin/services';
import { nextTick } from 'vue';

// eslint-disable-next-line vue/max-len
const assetsFiles = import.meta.glob('../../node_modules/@odin/assets/dist/themes/*/*_enc.scss', {eager: false, query: '?inline'});
type DynamicThemeImportType = { default: string };

let themeStyleElm: Element | null;

const switchThemeLocal = async (theme: string) => {
  console.log('switchTheme', theme);

  // Load the theme CSS
  // eslint-disable-next-line vue/max-len
  const assetsPackageImport = await assetsFiles[`../../node_modules/@odin/assets/dist/themes/${theme}/${theme}_enc.scss`]() as DynamicThemeImportType;

  // Create the theme <style>
  if (!themeStyleElm) {
    themeStyleElm = Object.assign(
      document.createElement('style'),
      {
        id: 'theme-styles',
      }
    );
    document.head.appendChild(themeStyleElm);
  }

  // Apply the loaded styles
  themeStyleElm.innerHTML = assetsPackageImport.default;
};

const linkId = 'ws-theme-stylesheet';
const switchThemeRemote = async (theme: string) => {
  const {data: manifest} = await Axios.get(
    config.assetUrl + '/manifest.json'
  );

  let linkElm = document.getElementById(linkId);
  if (!linkElm) {
    linkElm = Object.assign(
      document.createElement('link'),
      {
        id: linkId,
        rel: 'stylesheet',
        'data-type': 'theming-link',
      });

    document.body.appendChild(linkElm);
  }

  linkElm.setAttribute(
    'href',
    config.assetUrl + '/' + manifest[`src/styles/themes/${theme}/index.scss`]['file']
  );
};

export const switchTheme = async (newTheme: Theme) => {
  config.theme = newTheme;
  store.dispatch('theme/' + StoreActions.SET_THEME, {theme: newTheme});
  setConfigValues(config);
  env.MODE === 'development' ? switchThemeLocal(newTheme) : await switchThemeRemote(newTheme);

  nextTick(() => {
    const { theme } = useTheming();

    theme.value = newTheme;

    const { setTheme } = useThemingService();
    setTheme(newTheme);
  });
};

// If a theme preference is set in admin, load that one
const savedTheme = localStorage.getItem('odinAdminSavedTheme') as Theme;
if (savedTheme) {
  config.theme = savedTheme;
}

if (env.MODE === 'development' || savedTheme) {
  switchTheme(config.theme);
}

// @ts-ignore
window.switchTheme = switchTheme;
